import { bl_fi_bank_hdr_RowClass } from "../../../dbschema/bl_fi_bank_hdr.model";
import { BaseContainerModel } from "../../base-container.model";

export class BankContainerModel extends BaseContainerModel {
  bl_fi_bank_hdr: bl_fi_bank_hdr_RowClass = new bl_fi_bank_hdr_RowClass();
}
